import React from "react";
import AlertTile from "../../components/Uicomponent/AlertTile";

function Alerts () {
    return(
        <div className="container">
            <AlertTile />
        </div>
    )
  }

  
export default Alerts;